import { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Switch,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
} from '@material-ui/core'
import { Timer } from '@material-ui/icons'

export const DelayItem = (props) => {
  const [checkedDelay, setCheckedDelay] = useState(props.delayFromParent)

  const handleChange = (name) => (event) => {
    setCheckedDelay(event.target.checked)
    props.callbackFromParentDelay(event.target.checked)
  }

  const handleLabel = (delayValue) => {
    var labelText = ''
    if (delayValue) {
      labelText = '15 minute delay'
    } else {
      labelText = '2 minute delay'
    }
    return labelText
  }
  return (
    <div>
      <List className={props.className}>
        <ListItem>
          <ListItemIcon>
            <Timer />
          </ListItemIcon>
          <ListItemText primary={handleLabel(checkedDelay)} />
          <ListItemSecondaryAction>
            <Switch
              checked={checkedDelay}
              onChange={handleChange('checkedDelay')}
              value="checkedDelay"
            />
          </ListItemSecondaryAction>
        </ListItem>
      </List>
    </div>
  )
}

DelayItem.propTypes = {
  delayFromParent: PropTypes.bool.isRequired,
  callbackFromParentDelay: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
}
